import { useCallback, useState } from 'react';
import Select from 'react-select-2';
import type { VoidFunctionComponent } from 'react';
import type { ValueType } from 'react-select-2/lib/types';

import { confirmationMessage } from '../../../shared/InternalTools/cache';
import { useDialogContext } from '../../contexts/DialogContext';
import useAsyncStatus from '../../hooks/useAsyncStatus';
import { remove } from '../../redux/api';
import { selectOptionFactory } from '../../utils';
import { InlineLoaderButton } from '../generic/Button';
import Flex from '../generic/Flex';
import type { FailedFetchResponse } from '../../helpers/errors';

type InvalidateCacheComponentProps = {
  cacheKinds: string[];
};

const InvalidateCacheComponent: VoidFunctionComponent<InvalidateCacheComponentProps> = ({ cacheKinds }) => {
  const { onConfirm } = useDialogContext();
  const [cacheKind, setCacheKind] = useState<string>(cacheKinds[0] || 'NO-CANDIDATE-CACHE-KIND-FOUND!');
  const { status, onPending, onSuccess, onError } = useAsyncStatus();

  const removeCache = useCallback(async () => {
    onPending();
    try {
      await remove(`/api/internal-tools/caches/${cacheKind}`);
      onSuccess();
    } catch (err) {
      onError(err as FailedFetchResponse);
    }
  }, [cacheKind, onPending, onSuccess, onError]);

  return (
    <div className="card">
      <h3 className="card-title padding-bottom-sm">Invalidate Cache</h3>
      <Flex justify="left" gap={10}>
        <div className="width-quarter">
          <Select
            value={selectOptionFactory(cacheKind)}
            options={cacheKinds.map((f: string) => selectOptionFactory(f))}
            onChange={(option: ValueType<{ value: string; label: string }>) => {
              setCacheKind(option?.value);
            }}
            />
        </div>

        <InlineLoaderButton
          onClick={() => {
            onConfirm({
              title: 'Are you sure?',
              body: confirmationMessage(cacheKind),
              onConfirm: removeCache,
            });
          }}
          isLoading={status.loading}
          isDisabled={status.loading}
          >
          Submit
        </InlineLoaderButton>
      </Flex>
    </div>
  );
};

export default InvalidateCacheComponent;
